{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              7.453179299001505,
              43.85147491898957
            ],
            [
              9.899641635233849,
              43.206113227074525
            ],
            [
              12.867971755440209,
              39.05924289793023
            ],
            [
              11.956768840807257,
              37.13104992996563
            ],
            [
              16.241603529484905,
              30.692379874938723
            ],
            [
              38.961270455447874,
              30.097090463512927
            ],
            [
              37.49541398304319,
              37.43714395578557
            ],
            [
              29.20231501547437,
              41.556661373478505
            ],
            [
              13.277466910157415,
              46.29675404634409
            ],
            [
              9.120653546339014,
              45.206431310897756
            ],
            [
              7.453179299001505,
              43.85147491898957
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}